import TransactionItemProvider from './provider';
import TransactionItemView from './view';

export default TransactionItemProvider;

export {
	TransactionItemView as Component,
	TransactionItemProvider as Provider,
};
